import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
import icu0a from '../../assets/img/clinic/9.png';
import icu1b from '../../assets/img/clinic/10.png';
import { useState, useEffect } from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';


const ICU = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    const images = [icu0a, icu1b ];
     const backgroundImage = images[currentImageIndex];
    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/clinic-and-specialities">Our Specialized Medical Departments</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">ICU and Critical Care</li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">ICU and Critical Care</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Breadcrumb */}

            <div className="content">
              {/* Full-Width Background with Minimal Text */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                        <p>ICU and Critical Care at Hitkari Hospital</p>
                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                           
                            <div className="terms-content">
                                <div className="terms-text">
                                    <h3>ICU and Critical Care at Hitkari Hospital</h3>
                                    <p>At Hitkari Hospital, our Intensive Care Unit (ICU) and Critical Care Department stands as a cornerstone of our commitment to saving lives and offering unparalleled healthcare. Combining advanced medical expertise with cutting-edge technology, we cater to patients requiring immediate and specialized attention in critical and life-threatening conditions.</p>

                                </div>
                                 <div className="terms-text">
                                      <h3>Understanding ICU and Critical Care</h3>
                                      <br />
                                      <p>Critical care, often referred to as intensive care, involves continuous and comprehensive treatment for patients who are severely ill or injured. It requires advanced monitoring, specialized equipment, and highly trained healthcare professionals to manage complex and rapidly changing medical conditions.</p>
                                      <p><strong>Who Needs ICU and Critical Care?</strong></p>
                                      <p>Patients admitted to our ICU may include those experiencing:</p>
                                     <ul>
                                            <li><strong>Severe Respiratory Distress:</strong> Conditions such as pneumonia, Acute Respiratory Distress Syndrome (ARDS), or complications requiring ventilatory support.</li>
                                            <li><strong>Life-Threatening Cardiac Issues:</strong> Including heart attacks, arrhythmias, congestive heart failure, or cardiogenic shock.</li>
                                            <li><strong>Neurological Emergencies:</strong> Stroke, brain hemorrhage, traumatic brain injuries, or spinal cord injuries.</li>
                                            <li><strong>Sepsis and Septic Shock:</strong> Life-threatening infections affecting multiple organ systems.</li>
                                            <li><strong>Post-Operative Complications:</strong> Monitoring and care for patients recovering from high-risk or complex surgeries.</li>
                                            <li><strong>Trauma Cases:</strong> Serious injuries resulting from accidents, falls, or other emergencies requiring immediate intervention.</li>
                                       </ul>

                                </div>
                                 <div className="terms-text">
                                    <h3>Specialized Facilities in Our ICU</h3>
                                    <br />
                                       <p>Our ICU is equipped with state-of-the-art technology and follows global standards for critical care. Key features include:</p>
                                       <ul>
                                           <li><strong>24/7 Monitoring and Support:</strong> Advanced bedside monitors track real-time patient vitals like heart rate, oxygen saturation, blood pressure, and temperature.</li>
                                           <li><strong>Mechanical Ventilation Systems:</strong> For patients with compromised breathing due to critical conditions.</li>
                                            <li><strong>Advanced Cardiac Life Support (ACLS):</strong> State-of-the-art defibrillators, pacemakers, and medication infusions for heart-related emergencies.</li>
                                            <li><strong>Dialysis Support:</strong> For patients with acute or chronic kidney failure requiring immediate renal replacement therapy.</li>
                                            <li><strong>Infection Control Protocols:</strong> A strict sterile environment reduces the risk of hospital-acquired infections, with dedicated isolation rooms for infectious cases.</li>
                                            <li><strong>Emergency Equipment Readiness:</strong> From rapid blood transfusions to high-precision diagnostic imaging, our ICU ensures immediate access to life-saving interventions.</li>
                                      </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Our ICU Team: Expertise and Compassion</h3>
                                    <br />
                                     <p>At Hitkari Hospital, our critical care team comprises highly skilled professionals, including:</p>
                                     <ul>
                                        <li><strong>Intensivists and Critical Care Physicians:</strong> Experts in managing critically ill patients and coordinating multidisciplinary care.</li>
                                          <li><strong>Pulmonologists:</strong> Specialists handling complex respiratory cases.</li>
                                          <li><strong>Cardiologists and Neurologists:</strong> For patients requiring specialized intervention.</li>
                                         <li><strong>Anesthesiologists:</strong> Ensuring optimal sedation and pain management.</li>
                                         <li><strong>Critical Care Nurses:</strong> Trained in advanced critical care, offering around-the-clock monitoring and emotional support.</li>
                                         <li><strong>Nutritionists and Physiotherapists:</strong> For comprehensive care addressing recovery needs.</li>
                                       </ul>

                                </div>
                                 <div className="terms-text">
                                   <h3>Advanced Procedures and Life-Saving Techniques</h3>
                                    <br />
                                      <ul>
                                            <li><strong>High-Flow Nasal Cannula Therapy:</strong> For patients requiring oxygen therapy without mechanical ventilation.</li>
                                           <li><strong>Targeted Temperature Management (TTM):</strong> To prevent brain injury in cardiac arrest survivors.</li>
                                            <li><strong>Hemodynamic Monitoring:</strong> To track and stabilize blood flow and organ function.</li>
                                           <li><strong>Sedation and Pain Management Protocols:</strong> Ensuring comfort while prioritizing safety and recovery.</li>
                                      </ul>
                                </div>
                                <div className="terms-text">
                                    <h3>Family-Centric Approach</h3>
                                    <br />
                                    <p>We understand that having a loved one in critical care is stressful. Our team ensures:</p>
                                    <ul>
                                          <li><strong>Transparent Communication:</strong> Regular updates and discussions about the patient’s condition.</li>
                                           <li><strong>Counseling Services:</strong> For emotional support during challenging times.</li>
                                            <li><strong>Comfortable Amenities:</strong> Family waiting areas near the ICU, ensuring loved ones remain close.</li>
                                     </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Why Choose Hitkari Hospital’s ICU?</h3>
                                     <br />
                                    <ul>
                                           <li><strong>State-of-the-Art Infrastructure:</strong> Advanced medical equipment ensures prompt and accurate interventions.</li>
                                           <li><strong>Patient-Centered Care:</strong> Every decision and treatment plan is tailored to the patient’s specific needs.</li>
                                           <li><strong>Proven Track Record:</strong> Consistently high success rates, even in complex and severe cases.</li>
                                           <li><strong>Multidisciplinary Collaboration:</strong> Specialists from various fields work together to offer holistic care.</li>
                                            <li><strong>Post-ICU Recovery Programs:</strong> Tailored plans to help patients regain strength and return to normal life.</li>
                                      </ul>
                                </div>
                                  <div className="terms-text">
                                    <h3>Emergency Preparedness at Hitkari Hospital</h3>
                                     <br />
                                     <p>Our ICU and Critical Care Unit is always prepared for emergencies, whether it’s managing large-scale accidents or individual critical cases. We are committed to quick response times, expert diagnostics, and immediate interventions.</p>
                                </div>
                                <div className="terms-text">
                                    <h3>Commitment to Excellence</h3>
                                     <br />
                                    <p>At Hitkari Hospital, we believe that ICU care extends beyond medical expertise. It’s about providing emotional support, maintaining patient dignity, and delivering hope in the most trying times.</p>
                                     <p>For unparalleled critical care, trust Hitkari Hospital to stand by your side. Your health and life are our priorities.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                </div>
                                <div className="footer-about-content">
                                    <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                    <div className="social-icon">
                                        <ul>
                                            <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Patients</h2>
                                <ul>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                    <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                    <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                    <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title"
                                >
                                    For Patients
                                </h2>
                                <ul>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                    <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                    <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                            <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                                <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                                <span>PIN – 344022</span>
                                            </div>
                                        </a>
                                    </div>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                            <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                            02988-223100
                                        </a>
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                            hitkarihospitalblt2015@gmail.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="copyright-text">
                                    <p className="mb-0">
                                        <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
};

export default ICU;